'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import * as SelectPrimitive from '@radix-ui/react-select';
import * as React from 'react';
import { RxCaretSort, RxCheck } from 'react-icons/rx';
import { inputVariants, selectCheckVariants, selectContentVariants, selectItemVariants, } from '../../styles';
import { cn } from '../../utils';
import { ScrollArea } from '../ScrollArea/ScrollArea';
/* eslint-disable react/prop-types */
/**
 * Select component
 *
 * https://ui.shadcn.com/docs/components/select
 */
const SelectRoot = SelectPrimitive.Root;
const SelectGroup = SelectPrimitive.Group;
const SelectValue = SelectPrimitive.Value;
const SelectTrigger = React.forwardRef(({ className, children, ...props }, ref) => (_jsxs(SelectPrimitive.Trigger, { ref: ref, className: cn(inputVariants(), 'group flex items-center justify-between whitespace-nowrap data-[placeholder]:text-muted-foreground', className), ...props, children: [children, _jsx(SelectPrimitive.Icon, { asChild: true, className: "text-foreground", children: _jsx(RxCaretSort, { className: "size-4 opacity-50" }) })] })));
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;
const SelectContent = React.forwardRef(({ className, children, position = 'popper', maxHeight = '320px', ...props }, ref) => {
    return (_jsx(SelectPrimitive.Portal, { children: _jsx(SelectPrimitive.Content, { ref: ref, className: cn(selectContentVariants({
                popper: position === 'popper' ? 'active' : 'none',
            }), className), position: position, ...props, children: _jsxs(ScrollAreaPrimitive.Root, { type: "auto", className: "relative overflow-hidden", children: [_jsx(SelectPrimitive.Viewport, { asChild: true, children: _jsx(ScrollAreaPrimitive.Viewport, { className: cn('h-full w-full rounded-[inherit] p-1', position === 'popper'
                                ? 'max-h-[min(var(--max-popper-height),var(--radix-select-content-available-height))] w-full min-w-[var(--radix-select-trigger-width)]'
                                : 'max-h-[var(--max-popper-height)]'), style: {
                                '--max-popper-height': maxHeight,
                                // Resolves React warning: https://github.com/radix-ui/primitives/issues/2059
                                overflowY: undefined,
                            }, children: children }) }), _jsx(ScrollArea.ScrollBar, {}), _jsx(ScrollAreaPrimitive.Corner, {})] }) }) }));
});
SelectContent.displayName = SelectPrimitive.Content.displayName;
const SelectLabel = React.forwardRef(({ className, ...props }, ref) => (_jsx(SelectPrimitive.Label, { ref: ref, className: cn('px-2 py-1.5 text-sm font-semibold', className), ...props })));
SelectLabel.displayName = SelectPrimitive.Label.displayName;
const SelectItem = React.forwardRef(({ className, children, ...props }, ref) => (_jsxs(SelectPrimitive.Item, { ref: ref, className: cn(selectItemVariants({ withFocus: 'highlight' }), className), ...props, children: [_jsx("span", { className: selectCheckVariants(), children: _jsx(SelectPrimitive.ItemIndicator, { children: _jsx(RxCheck, { className: "size-4" }) }) }), _jsx(SelectPrimitive.ItemText, { children: children })] })));
SelectItem.displayName = SelectPrimitive.Item.displayName;
const SelectSeparator = React.forwardRef(({ className, ...props }, ref) => (_jsx(SelectPrimitive.Separator, { ref: ref, className: cn('-mx-1 my-1 h-px bg-muted', className), ...props })));
SelectSeparator.displayName = SelectPrimitive.Separator.displayName;
export const Select = Object.assign(SelectRoot, {
    Group: SelectGroup,
    Value: SelectValue,
    Trigger: SelectTrigger,
    Content: SelectContent,
    Label: SelectLabel,
    Item: SelectItem,
    Separator: SelectSeparator,
});
//# sourceMappingURL=Select.js.map